// extracted by mini-css-extract-plugin
module.exports = {"sideMenuLogo":"SideMenu_sideMenuLogo__2jjwA","icon":"SideMenu_icon__2Cpw2"};